import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { deleteItem } from '../actions';


// Removes values from store when element unmounts
export function useFormElementCleanUp(path) {
  const dispatch = useDispatch();
  const pathRef = useRef();

  // Keeps value of pathRef up-to-date
  useEffect(() => {
    pathRef.current = path
  }, [path]);

  // Using ref means it doesn't have to be included in dependencies array.
  // This means that this will ONLY run on unmount, not remount
  useEffect(() => {
    return () => { 
      if (pathRef && pathRef.current) {
        dispatch(deleteItem(pathRef.current))
      }
    }
  },[dispatch])

}